export const bytesToSize = (bytes) => {
  let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

const getFileType = (file) => {
  let type = file.type;
  let images = [
      "image/webp", //.webp
      "image/png", //.png
      "image/svg+xml", //.svg
      "image/jpeg", //.jpeg .jpg
      "image/gif", //.gif
    ],
    videos = [
      "video/3gpp",
      "video/ogg",
      "video/mp4",
      "video/mpeg",
      "video/quicktime",
      "video/webm",
      "video/x-ms-wmv",
      "video/x-msvideo",
    ],
    audios = [
      "audio/mp3", //.mp3
      "audio/ogg", //.ogg
      "audio/mpeg",
      "audio/x-m4a",
    ],
    compresseds = [
      "application/x-zip-compressed", //.zip
      "application/x-rar-compressed", //.tar
      "application/zip", //.zip
      "application/x-zip-compressed", //.zip
      "application/x-tar", //.tar
      "application/x-7z-compressed",
    ],
    documents = [
      "application/pdf",
      "application/vnd.ms-excel", //.csv
      "application/msword", //.doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //.docx
      "application/rtf", //.rtf
      "application/vnd.ms-powerpoint",
    ];
  if (images.indexOf(type) !== -1) {
    return 0;
  } else if (videos.indexOf(type) !== -1) {
    return 1;
  } else if (audios.indexOf(type) !== -1) {
    return 2;
  } else if (compresseds.indexOf(type) !== -1) {
    return 3;
  } else if (documents.indexOf(type) !== -1) {
    return 4;
  }
};

export const createFileObject = (file) => {
  let fileType = getFileType(file);
  let fileData = "";

  fileData = window.URL.createObjectURL(file);

  let returnedData = {
    file,
    fileData,
    fileType,
  };
  switch (fileType) {
    case 0: // image files preview
      // remove loader
      returnedData.type = "image";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;
      break;
    case 1: // video files preview
      // remove loader

      returnedData.type = "video";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;
      break;
    case 2: // audio files preview
      returnedData.type = "audio";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;

      break;
    case 3: // compresseds files preview
      // remove loader

      returnedData.type = "compress";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;

      break;
    case 4: // documents files preview
      // remove loader

      returnedData.type = "file";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;
      break;
    default:
      break;
  }

  return returnedData;
};
